import useGoBack from "./useGoBack";

export default function useRemoveTab({
  taskKey,
  sectionIndex,
}: {
  taskKey: string;
  sectionIndex?: number;
}) {
  const goBack = useGoBack();
  const handleRemoveTab = () => {
    goBack();
  };

  return { removeTab: handleRemoveTab };
}